import React from "react";
import { motion } from "framer-motion";
import "./WeeklyActivityChart.css";

/**
 * Animated Mon–Sun bar chart. `data` items: { day, label, volumeKg }.
 * Bars scale relative to the week's max value; a 0-value day renders as
 * a flat "—" rest-day marker instead of an empty bar.
 */
const WeeklyActivityChart = ({ data = [] }) => {
  const max = Math.max(...data.map((d) => d.volumeKg), 1);

  return (
    <div className="weekly-chart" role="img" aria-label="Weekly training volume by day">
      {data.map((d, i) => {
        const heightPct = d.volumeKg > 0 ? Math.max((d.volumeKg / max) * 100, 6) : 0;
        return (
          <div className="weekly-chart-col" key={d.day}>
            <div className="weekly-chart-track">
              {d.volumeKg > 0 ? (
                <motion.div
                  className="weekly-chart-bar"
                  initial={{ height: 0 }}
                  animate={{ height: `${heightPct}%` }}
                  transition={{ duration: 0.6, delay: i * 0.06, ease: "easeOut" }}
                />
              ) : (
                <span className="weekly-chart-rest">—</span>
              )}
            </div>
            <span className="weekly-chart-label">{d.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default WeeklyActivityChart;
